import type { SearchState } from '../constants/search';

export const getProducts: ({
	selectedProducts,
	availableProducts,
}: Pick<SearchState, 'selectedProducts' | 'availableProducts'>) => {
	selectedProduct: string;
	filteredProducts: string[];
	availableProducts: string[];
} = ({
	selectedProducts,
	availableProducts,
}: Pick<SearchState, 'selectedProducts' | 'availableProducts'>) => {
	const selectedProduct = selectedProducts?.[0];
	const filteredProducts = selectedProduct ? [selectedProduct] : availableProducts;
	return {
		selectedProduct,
		filteredProducts,
		availableProducts,
	};
};
